import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

import { PuSubscribable } from '@app/utils/pu-subscribe';
import { ImageCaptureMode } from '@main-application/inspections/models/rest-inspections-model.interface';

import { fileOptions } from '../constant-questions/template-editor-constant-questions.component';

@Component({
  selector: 'app-camera-options',
  templateUrl: './camera-options.component.html',
  styleUrls: ['./camera-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraOptionsComponent extends PuSubscribable implements OnInit {
  @Input() set captureMode(_captureMode: ImageCaptureMode) {
    if (_captureMode === this.form?.get('fileOption')?.value) {
      return;
    }
    this.form.get('fileOption')?.setValue(_captureMode);
  }
  @Output() submitForm = new EventEmitter<ImageCaptureMode>();

  form: FormGroup = new FormGroup({
    fileOption: new FormControl(),
  });
  readonly fileOptions = fileOptions;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form
      .get('fileOption')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(value => this.submitForm.emit(value))
      .untilDestroyed(this);
  }
}
